import { TranslationsMap } from '../translations.map';

export const enLocale: TranslationsMap = {
  // Common
  account_header: 'Account',
  overview: 'Overview',
  profile: 'Profile',
  sign_out: 'Sign out',
  save: 'Save',
  days: 'Days',
  weeks: 'Weeks',
  cancel: 'Cancel',
  save_changes: 'Save changes',
  general_information: 'General information',
  enabled: 'Enabled',
  disabled: 'Disabled',
  confirm: 'Confirm',
  error: 'Error',
  learn_more: 'Learn more',
  about: 'About',

  // Overview
  welcome_user: 'Welcome, {{name}}!',
  organization_header: 'Organizations',
  organizational_units_header: 'Organizational units',
  studies_header: 'Studies',
  data_sources_header: 'Data sources',
  admins_header: 'Admins',
  first_name_header: 'First name',
  last_name_header: 'Last name',
  role_header: 'Roles',
  participants_header: 'Participants',
  name_header: 'Name',
  display_name_header: 'Display name',
  created_header: 'Created',
  joined_header: 'Joined',
  researchers_header: 'Researchers',
  email_header: 'Email',
  phone_number_header: 'Phone number',

  admin: 'Admin',
  researcher: 'Researcher',
  users: 'Users',
  manager: 'Manager',

  study: 'Study',
  data_source: 'Data source',

  error_loading_overview: 'Error while fetching overview',
  error_getting_organization: 'Error while fetching organization',
  error_getting_study: 'Error while fetching study',

  num_participants: 'participants',
  num_researchers: 'researchers',
  num_studies: 'studies',
  num_organizational_units: 'organizational units',
  num_data_sources: 'data sources',

  organization_name: 'Organization name',
  edit_organization: 'Edit organization',
  actions: 'Actions',
  create_study: 'Create study',
  creation_date: 'Creation date',
  organization_overview: 'Organization overview',
  organization_updated_successfully: '{{name}} updated successfully 🎉',

  success_invitation_code_refreshed: 'Invitation code was refreshed successfully 🎉',
  success_invitation_code_copied: 'Invitation code copied to clipboard',
  copy_invitation_code: 'Copy invitation code',
  refresh_invitation_code: 'Refresh invitation code',
  edit_study: 'Edit study',

  invite_researcher: 'Invite researcher',
  researcher_invited_successfully: 'Researcher invited successfully',
  invite: 'Invite',

  example_num: 'Ex. 10',
  study_updated_successfully: '{{name}} updated successfully 🎉',
  study_name: 'Study name',
  description: 'Description',
  expected_total_participants: 'Expected total participants',
  expected_time_in_study: 'Expected time in the study',
  expected_participant_duration_in_study: 'Expected participant duration in the study',
  start_date: 'Start date',
  completion_date: 'Completion date',
  no_participants_in_study: 'No participants have joined this study',

  create_study_for: 'Create study for {{name}}',
  expected_participants: 'Expected participants',
  enter_study_description: 'Enter the study description',

  edit_data_source: 'Edit data source',
  delete_data_source: 'Delete data source',
  no_description_provided: 'No description provided',

  no_organizational_units_created:
    'No organizational units have been created for this organization',
  no_researchers_created: 'No researchers have been created for this organization',
  no_data_sources_created: 'No data sources have been created for this organization',
  no_studies_created: 'No studies have been created for this organization',
  error_fetching_organizations: 'There was an error while fetching your organizations',

  no_researchers_assigned_to_this_study: 'No researchers assigned to this study.',
  no_researchers_assigned_to_this_data_source: 'No researchers assigned to this data source.',

  unassign_researcher: 'Unassign researcher',
  unassign_researcher_from_data_source_confirmation:
    'Are you sure you want to unassign this researcher from data source {{name}} (ID: {{id}})',
  unassign_researcher_from_study_confirmation:
    'Are you sure you want to unassign this researcher from study {{name}} (ID: {{id}})',
  user_assigned_to_entity: 'User assigned to {{entityName}}',
  assign_researcher: 'Assign researcher',
  assign_researcher_confirmation:
    'Assigning this user to the {{selectedEntityType}} will grant access to all {{selectedEntityType}} data and features. Are you sure you want to proceed?',
  assign_to_study_or_data_source: 'Assign to study or data source',

  find_entities: 'Find entities',
  no_studies_found: 'No studies found',
  no_data_sources_found: 'No data sources found',

  organization_wide_access: 'Organization wide access',
  confirm_modifying_organization_wide_access: 'Confirm modifying organization wide access',
  disable_organization_wide_access_confirmation:
    'Are you sure you want to disable organization wide access? This will revoke all researchers access to all studies and data sources in the organization. Researchers will only be able to access studies and data sources that they have been explicitly assigned to.',
  enable_organization_wide_access_confirmation:
    'Are you sure you want to enable organization wide access? This will grant all researchers access to all studies and data sources in the organization.',
  note_change_not_saved_until_click_save:
    'Note that this change will not save until you click the save button.',

  no_org_assigned: "You haven't been assigned to any organizations yet",
  request_admin_to_join_org:
    'To join an organization, please request access from your administrator',
  contact_administrator: 'Contact administrator',

  // Profile
  my_profile: 'My profile',
  profile_info: 'Profile information',
  change_password: 'Change password',

  new_passwords_dont_match: 'New password and confirm password must match',
  success_password_reseted: 'Password reset was successful 🎉',
  old_password: 'Old password',
  new_password: 'New password',
  confirm_password: 'Confirm password',

  success_profile_updated: 'Profile update was successful 🎉',
  email_phone_verified: 'Your {{attribute}} was successfully verified 🎉',
  email: 'email',
  phone_number: 'phone number',
  verification_sent: 'A verification code has been sent to your {{attribute}}',
  basic_information: 'Basic information',
  information_only_visible_to_you: 'This information is only visible to you',
  error_loading_profile: 'Error while loading profile',
  error_editing_profile: 'Error while editing profile',
  last_updated: 'Last updated',
  user_roles: 'User roles',
  edit: 'Edit',
  verify_your: 'Verify your {{attribute}}',

  verify_header: 'Verify',
  please_enter_verification_sent: 'Please enter the verification code sent to your {{attribute}}',

  enter_verification_code: 'Enter verification code',
  resend_verification_code: 'Resend verification code',

  // Not found
  oops_page_not_found: 'Oops! Page not found.',
  could_not_find_page: "We couldn't find the page you are looking for.",
  back_to_home_page: 'Go back to home page',

  // Create Cohort Builder
  create_cohort_builder: 'Create Cohort Builder',
  create_cohort: 'Create Cohort',
  no_cohorts_created: 'No cohorts created yet',
  no_cohorts_created_description:
    'Cohorts help you define and manage subsets of your data for targeted analysis. Create your first cohort to get started.',

  // Dataset
  data: 'Data',

  // Dataset Overview
  time_span: 'Time span',
  record_count: 'Record count',
  data_provider: 'Data provider',
  data_dictionary: 'Data dictionary',
  completeness_score: 'Completeness score',
  column_name: 'Column name',
  data_dictionary_description: 'Data dictionary',
  column_type: 'Data type',
  column_description: 'Description',
  column_completeness_score: 'Completeness score',
  select_table: 'Select table',
  search_column_name_type_description: 'Search by column name, type or description',

  // Dataset Cohort
  cohort: 'Cohort',
  search_cohort: 'Search by name',
  action_create_cohort: 'Create cohort',
  cohort_column_name_header: 'Column name',
  cohort_column_owner_header: 'Owner',
  cohort_column_description_header: 'Description',
  cohort_column_patient_count_header: 'Patients',

  // Dataset Codes
  no_codes_created: 'No code sets created yet',
  no_codes_created_description:
    'Code sets help you organize and manage reusable groups of codes for your analytics. Create a new code set in Analytics to get started.',

  // Complete Account Creation
  create_your_account: 'Create your account',
  complete_your_account_details: 'Complete your account details to start exploring Medeloop',
  enter_given_name: 'Enter given name',
  enter_family_name: 'Enter family name',
  enter_phone_number: 'Enter phone number',
  to_change_use_sso_provider: 'To change {{field}}, use your SSO provider',
  given_name: 'Given name',
  family_name: 'Family name',
  continue: 'Continue',
  something_wrong_authentication: 'Something went wrong with authentication',
  something_went_wrong: 'Something went wrong',
  code_inserted_wrong: 'The code inserted was incorrect',
  enter_code_to_destination: 'Enter the code that has been sent by SMS to: {{destination}}',
};